'use client';

import React, {
  ComponentType,
  FunctionComponent,
  memo,
  MouseEvent,
  PropsWithChildren,
  RefObject,
} from 'react';
import classnames from 'classnames/bind';
import { resolveUrl } from '@portal-root/geo-utils';
import { EColors } from '@/_types';
import { TAnchorRel, TIconPropType, TReturnValue, TTarget } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);

const BLOCK_NAME = 'BrowserLink';

type TProps = PropsWithChildren<{
  rel?: TAnchorRel;
  routeName: string;
  target?: TTarget;
  linkRef?: RefObject<HTMLAnchorElement>;
  onClick?: ({ event, routeName }: TReturnValue) => void;
  color?: EColors;
  leftIcon?: ComponentType<TIconPropType> | FunctionComponent<TIconPropType>;
  rightIcon?: ComponentType<TIconPropType> | FunctionComponent<TIconPropType>;
  iconClassName?: string;
  isResolveUrl?: boolean;
}>;

export const BrowserLink = memo(function BrowserLinkComponent({
  routeName,
  children,
  target = '_self',
  rel,
  linkRef,
  onClick,
  color = EColors.RICH_GREY,
  iconClassName,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  isResolveUrl = true,
}: TProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) =>
    onClick?.({ event, routeName });

  const href = isResolveUrl ? resolveUrl(routeName) : routeName;

  return (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--${color}`]: color,
      })}
    >
      <a
        ref={linkRef}
        className={cn(`${BLOCK_NAME}__link`)}
        href={href}
        onClick={handleClick}
        rel={rel}
        target={target}
      >
        {LeftIcon && (
          <div className={cn(`${BLOCK_NAME}__icon-wrapper`, iconClassName)}>
            <LeftIcon />
          </div>
        )}
        {children}
        {RightIcon && (
          <div className={cn(`${BLOCK_NAME}__icon-wrapper`, iconClassName)}>
            <RightIcon className={cn(`${BLOCK_NAME}__icon`)} />
          </div>
        )}
      </a>
    </div>
  );
});
